module.exports = __webpack_public_path__ + "img/gbwhatsapp-vs-fmwhatsapp.ee90b4d7.webp";